var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { key: _vm.id }, [
    _vm.shortFormat
      ? _c("span", { key: _vm.id }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.prefix ? _vm.prefix + " " : "") +
              "\n        " +
              _vm._s(
                _vm._f("dateToHourFromSecondsShortFormat")(
                  _vm.time,
                  _vm.$i18n.locale,
                  _vm.secondVisible
                )
              ) +
              "\n        " +
              _vm._s(_vm.suffix ? " " + _vm.suffix : "") +
              "\n    "
          ),
        ])
      : _c("span", { key: _vm.id }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.prefix ? _vm.prefix + " " : "") +
              "\n        " +
              _vm._s(_vm._f("dateToHourFromSeconds")(_vm.time)) +
              "\n        " +
              _vm._s(_vm.suffix ? " " + _vm.suffix : "") +
              "\n    "
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }